import React from 'react';
import { ToroLearnIcon } from 'presentation/components/icon';
import { useCourse } from 'presentation/hooks/courses';

import './styles.scss';

interface IProps {
    setShowToroFormModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ToroLearnLockedCard = ({ setShowToroFormModal }: IProps): JSX.Element => {
    const { course } = useCourse();

    if (!course) return <span></span>;

    return (
        <div className="locked-card row align-items-center py-4">
            <div className="col-12 col-sm-2 text-center">
                <ToroLearnIcon icon="lock" fill="#E7517E" className="mx-auto" />
            </div>
            <div className="col-10 col-sm-6 p-0">
                <h4>Invista com a Toro para continuar.</h4>
                <p className="text-gray-dark mb-0">
                    Ative sua conta transferindo a partir de R$100 e tenha acesso grátis a todos os cursos da Toro.
                </p>
            </div>
            <div className="col-12 col-sm-4 text-center">
                <a type="button" onClick={() => setShowToroFormModal(true)} className="btn btn-primary">
                    Comece a investir
                </a>
            </div>
        </div>
    );
};
